// Importy modułów Swiper
const { Navigation, Pagination } = window;

// Rejestracja modułów globalnie dla Swiper
if (window.Swiper && window.SwiperNavigation && window.SwiperPagination) {
    window.Swiper.use([window.SwiperNavigation, window.SwiperPagination]);
}

// var swiper = new Swiper(".specjalizacjeSwiper", {
//   grabCursor: false,
//   simulateTouch: false,
//   slidesPerView: 3,
//   spaceBetween: 16,
//   loop: true,
//   navigation: {
//       nextEl: ".specjalizacjeSwiper-next",
//       prevEl: ".specjalizacjeSwiper-prev",
//     },
// });


// $(function() {
    //   $('.twentytwenty-init').twentytwenty({
        //     orientation: 'vertical',
        //     move_with_handle_only: true,
        //   });
        // })
        


var swiper = new Swiper(".realisationsSwiper", {
    slidesPerView: 1,
    spaceBetween: 180,
    loop: true,
    centeredSlides: true,
    navigation: {
        nextEl: ".realisationsSwiper-button-next",
        prevEl: ".realisationsSwiper-button-prev",
    },
    pagination: {
        el: ".realisationsSwiper-pagination",
        clickable: true,
    },
    breakpoints: {
        640: {
            spaceBetween: 20,
        },
        768: {
            spaceBetween: 40,
        },
        1560: {
            spaceBetween: 60,
        },
    }
});